import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import Stats from '../components/sections/Stats';
import SuccessStories from '../components/sections/SuccessStories';
import Partners from '../components/sections/Partners';
import Contact from '../components/sections/Contact';

const Home = () => {
  return (
    <main>
      <Hero />
      <Services />
      <Stats />
      <SuccessStories />
      <Partners />
      <Contact />
    </main>
  );
};

export default Home;
